export default __webpack_public_path__ + "static/media/logo.ecb4901b.png";